import { createSelector } from "reselect";
import { sortCompare } from "~/utils/utils";
import { getRawConfigOption } from "./selector.configOptions";
import { getActiveProjects } from "./selector.projects";

export const getFavoriteProjectIds = (state) => state.favorites.get("projects").toArray();
export const getFavoriteTeamIds = (state) => state.favorites.get("teams")?.toArray();
export const getHasFavoriteTeams = createSelector(getFavoriteTeamIds, (favoriteTeamIds) => favoriteTeamIds?.length > 0);

export const getActiveFavoriteProjects = createSelector(
  getFavoriteProjectIds,
  (state) => getActiveProjects(state),
  (getFavoriteProjectIds, getActiveProjects) => {
    const favorites = [];
    const activeProjectsKeys = Object.keys(getActiveProjects.toJS());
    const activeProjects = getActiveProjects.toJS();
    getFavoriteProjectIds.map((item) => {
      if (activeProjectsKeys.some((value) => value === item.toString())) {
        favorites.push(activeProjects[item]);
      }
    });
    return favorites;
  }
);

export const getSortedActiveFavoriteProjects = createSelector(
  getActiveFavoriteProjects,
  (state) => getRawConfigOption(state, "show_project_id"),
  (getActiveFavoriteProjects, showProjectId) => {
    let sortedFavorites;
    if (showProjectId) {
      sortedFavorites = getActiveFavoriteProjects.sort((a, b) =>
        sortCompare(parseInt(a.project_number), parseInt(b.project_number))
      );
    } else {
      sortedFavorites = getActiveFavoriteProjects.sort((a, b) =>
        sortCompare(a.name.toLowerCase(), b.name.toLowerCase())
      );
    }
    return sortedFavorites;
  }
);
